import { PlatformHealthVariant } from './platformHealth';
import {
    DEFAULT_PLATFORM_HEALTH_THRESHOLD,
    normalizePlatformHealthThreshold
} from './platformHealthThresholds';

interface PlatformHealthTargetStorage {
    getItem: (key: string) => string | null;
    setItem: (key: string, value: string) => void;
}

export const getPlatformHealthTargetStorageKey = (variant: PlatformHealthVariant): string =>
    `voicify_platform_health_target_${variant}_v1`;

const getBrowserStorage = (): PlatformHealthTargetStorage | undefined => {
    try {
        return typeof window === 'undefined' ? undefined : window.localStorage;
    } catch {
        return undefined;
    }
};

export const loadPlatformHealthTarget = (
    variant: PlatformHealthVariant,
    storage: PlatformHealthTargetStorage | undefined = getBrowserStorage()
): number => {
    if (!storage) return DEFAULT_PLATFORM_HEALTH_THRESHOLD;
    try {
        const storedValue = storage.getItem(getPlatformHealthTargetStorageKey(variant));
        return storedValue == null
            ? DEFAULT_PLATFORM_HEALTH_THRESHOLD
            : normalizePlatformHealthThreshold(storedValue) ?? DEFAULT_PLATFORM_HEALTH_THRESHOLD;
    } catch {
        return DEFAULT_PLATFORM_HEALTH_THRESHOLD;
    }
};

export const savePlatformHealthTarget = (
    variant: PlatformHealthVariant,
    value: unknown,
    storage: PlatformHealthTargetStorage | undefined = getBrowserStorage()
): boolean => {
    const target = normalizePlatformHealthThreshold(value);
    if (!storage || target == null) return false;
    try {
        storage.setItem(getPlatformHealthTargetStorageKey(variant), String(target));
        return true;
    } catch {
        return false;
    }
};
